import React, { useState } from "react";
import { motion } from "framer-motion";
import { Check, ChevronDown } from "lucide-react";

// "What I've learned" cumulative summary. Collapsible on mobile.
export const AssessmentMemory = ({ factors = [] }) => {
  const [open, setOpen] = useState(false);
  if (!factors.length) return null;
  return (
    <div
      className="rounded-xl border border-white/10 mb-6"
      style={{ backgroundColor: "#0B1120" }}
      data-testid="assessment-memory"
    >
      {/* Mobile collapsed header */}
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="sm:hidden w-full flex items-center justify-between px-4 py-3 text-left"
        data-testid="assessment-memory-toggle"
        aria-expanded={open}
      >
        <span className="text-sm text-white/80">
          Your profile so far &middot; {factors.length} factor{factors.length > 1 ? "s" : ""} identified
        </span>
        <ChevronDown size={16} className={`text-white/50 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <div className={`${open ? "block" : "hidden"} sm:block px-4 py-4`}>
        <div className="text-[11px] uppercase tracking-[0.18em] text-[#66B2FF] font-semibold mb-3">
          What I&apos;ve learned
        </div>
        <ul className="space-y-2">
          {factors.map((f, i) => (
            <motion.li
              key={f + i}
              initial={{ opacity: 0, x: -6 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.25 }}
              className="flex items-start gap-2 text-sm text-white/75"
            >
              <Check size={15} className="text-[#66B2FF] shrink-0 mt-0.5" />
              <span className="capitalize-first">{f}</span>
            </motion.li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AssessmentMemory;
